import { makeStyles } from "@material-ui/core";
import { createMuiTheme } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  tileBox: {
   
    border: '1px solid #ccc',
     margin: '5px',
    // borderTop: theme.palette.primary.main + ' solid 3px !important',
    
},
 
  topButtons: {
    margin: theme.spacing(1),
    float:'right',
    color:'white'
  },
  topButtonClose:{
    float:'right',
    // color:'white'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.overlayBg.background,
  },
}));

export const getMuiTheme = (theme) => {
  return createMuiTheme({
    ...theme,
    overrides: {
      MuiDialogContent:{
        root:{
          paddingTop:'0px'
        }
      },
      MuiDialogTitle: {
        root: {
          paddingBottom: "0px",
        },
      },
      MuiAlert:{
        message:{
          width:'100%'
        }
      }
      
    },
  });
}